// import { useEffect, useState } from "react";
// import { useShallow } from "zustand/react/shallow";
// import { RegulifyService } from "../../api/RegulifyService";
// import { useLoading } from "../../context/LoadingContext";
// import { useClinicalEvaluationStore } from "../../store/useClinicalEvaluationStore";
// import DateRangePicker from "../DateRangePicker";
// import StudyList from "./StudyList";

// const ProductConcept = ({ goToNextTab }) => {
//   const selectedStudy = useClinicalEvaluationStore(
//     useShallow((state) => state.selectedStudy)
//   );
//   const setSelectedStudy = useClinicalEvaluationStore(
//     (state) => state.setSelectedStudy
//   );

//   const [studies, setStudies] = useState([]);
//   const [form, setForm] = useState({});
//   const [isDrug, setIsDrug] = useState(false);
//   const { loading, setLoading } = useLoading();

//   const [dateRange, setDateRange] = useState({
//     minDate: null,
//     maxDate: null,
//   });

//   const handleDateChange = (newValue) => {
//     setDateRange(newValue);
//   };

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   /**
//    * Normalize backend response so UI always receives
//    * {
//    *   product_name,
//    *   company_name,
//    *   product_descrp,
//    *   folder,
//    *   settings,
//    *   metrics
//    * }
//    */
//   const normalizeStudies = (rawStudies) => {
//     if (!Array.isArray(rawStudies)) return [];

//     return rawStudies.map((item) => {
//       // NEW API FORMAT
//       if (item.study_folder_name) {
//         return {
//           product_name: item.settings?.product_name || item.study_folder_name,
//           company_name: item.settings?.company_name || "",
//           product_descrp: item.settings?.product_descrp || "",
//           is_drug: item.settings?.is_drug || false,
//           folder: item.study_folder_name,
//           settings: item.settings || {},
//           metrics: item.metrics || {},
//         };
//       }

//       // OLD API FORMAT
//       const key = Object.keys(item)[0];
//       const value = item[key];

//       return {
//         product_name: value?.settings?.product_name || key,
//         company_name: value?.settings?.company_name || "",
//         product_descrp: value?.settings?.product_descrp || "",
//         folder: key,
//         settings: value?.settings || {},
//         metrics: value?.metrics || {},
//       };
//     });
//   };

//   useEffect(() => {
//     const get_all_clinical_study = async () => {
//       try {
//         setLoading(true);

//         const response =
//           await RegulifyService.cle_get_all_clinical_study();

//         const normalized = normalizeStudies(
//           response?.data?.study_list || []
//         );

//         setStudies(normalized);

//         if (normalized.length > 0) {
//           if (!selectedStudy) {
//             setSelectedStudy(normalized[0]);
//           } else if (
//             !normalized.find(
//               (s) => s.product_name === selectedStudy.product_name
//             )
//           ) {
//             setSelectedStudy(undefined);
//           }
//         } else {
//           setSelectedStudy(undefined);
//         }
//       } catch (error) {
//         console.error("Error:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     get_all_clinical_study();
//   }, []);

//   useEffect(() => {
//     if (selectedStudy === undefined) {
//       setForm({});
//     }
//   }, [selectedStudy]);

//   const createClinicalStudy = async () => {
//     try {
//       setLoading(true);

//       const data = {
//         ...form,
//         date_range_from: dateRange.minDate,
//         date_range_to: dateRange.maxDate,
//         is_drug: isDrug,
//       };

//       const response =
//         await RegulifyService.cle_create_clinical_study(data);

//       if (response.data.status) {
//         setSelectedStudy({
//           product_name: data.product_name,
//           company_name: data.company_name,
//           product_descrp: data.product_descrp,
//         });

//         goToNextTab();
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const isFormComplete = () => {
//     return (
//       form.product_name &&
//       form.company_name &&
//       form.product_descrp &&
//       form.intended_use &&
//       form.users_description &&
//       dateRange.minDate &&
//       dateRange.maxDate
//     );
//   };

//   return (
//     <div className="flex h-[calc(100vh-180px)] overflow-y-scroll px-4">
//       {Array.isArray(studies) && studies.length > 0 && (
//         <div className="mr-6 w-full max-w-xs">
//           <StudyList
//             studies={studies}
//             selectedStudy={selectedStudy}
//             onSelect={setSelectedStudy}
//           />
//         </div>
//       )}

//       <div className="w-full max-w-xl">
//         {/* Selected Study */}
//         {selectedStudy && (
//           <div className="card border-base-300 bg-base-100 m-4 border p-4 shadow">
//             <div className="space-y-1">
//               <div>
//                 <span className="font-semibold">
//                   Product Name:
//                 </span>{" "}
//                 {selectedStudy?.product_name}
//               </div>

//               {selectedStudy?.company_name && (
//                 <div>
//                   <span className="font-semibold">
//                     Company Name:
//                   </span>{" "}
//                   {selectedStudy.company_name}
//                 </div>
//               )}

//               {selectedStudy?.product_descrp && (
//                 <div>
//                   <span className="font-semibold">
//                     Description:
//                   </span>{" "}
//                   {selectedStudy.product_descrp}
//                 </div>
//               )}
//             </div>

//             <div className="card-actions justify-end">
//               <button
//                 className="btn btn-primary"
//                 onClick={goToNextTab}
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Create Study Form */}
//         {(!selectedStudy?.product_name ||
//           !selectedStudy?.company_name) && (
//           <div className="card-body">
//             <form className="space-y-4">
//               <div className="form-control mt-4 w-full max-w-xl">
//                 <label className="label">
//                   <span className="label-text font-semibold">
//                     Company name:
//                   </span>
//                 </label>
//                 <input
//                   name="company_name"
//                   className="input input-bordered w-full"
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="form-control mt-4 w-full max-w-xl">
//                 <label className="label">
//                   <span className="label-text font-semibold">
//                     Study name:
//                   </span>
//                 </label>

//                 <input
//                   name="product_name"
//                   className="input input-bordered w-full"
//                   value={form.product_name || ""}
//                   onChange={(e) => {
//                     const sanitized = e.target.value.replace(
//                       /[^a-zA-Z0-9]/g,
//                       ""
//                     );

//                     handleChange({
//                       target: {
//                         name: "product_name",
//                         value: sanitized,
//                       },
//                     });
//                   }}
//                   required
//                 />
//               </div>

//               <div className="form-control mt-4 w-full max-w-xl">
//                 <label className="label">
//                   <span className="label-text font-semibold">
//                     Problem description:
//                   </span>
//                 </label>

//                 <textarea
//                   name="product_descrp"
//                   className="textarea w-full"
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="form-control mt-4 w-full max-w-xl">
//                 <label className="label">
//                   <span className="label-text font-semibold">
//                     Intended use:
//                   </span>
//                 </label>

//                 <textarea
//                   name="intended_use"
//                   className="textarea w-full"
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="form-control mt-4 w-full max-w-xl">
//                 <label className="label">
//                   <span className="label-text font-semibold">
//                     Patients/Users:
//                   </span>
//                 </label>

//                 <textarea
//                   name="users_description"
//                   className="textarea w-full"
//                   onChange={handleChange}
//                 />
//               </div>

//               <fieldset className="form-control border-base-300 mt-4 w-full max-w-xl rounded border p-4">
//                 <legend className="label label-text px-2 font-semibold">
//                   Custom filters
//                 </legend>

//                 <DateRangePicker
//                   dateRange={dateRange}
//                   onDateChange={handleDateChange}
//                 />

//                 <div className="mt-4">
//                   <label className="label cursor-pointer justify-start gap-3">
//                     <input
//                       type="checkbox"
//                       className="checkbox checkbox-primary"
//                       checked={isDrug}
//                       onChange={(e) =>
//                         setIsDrug(e.target.checked)
//                       }
//                     />

//                     <span className="label-text font-semibold">
//                       Is this for Drug
//                     </span>
//                   </label>
//                 </div>
//               </fieldset>

//               <button
//                 type="button"
//                 className="btn btn-primary w-full"
//                 disabled={loading || !isFormComplete()}
//                 onClick={createClinicalStudy}
//               >
//                 Next
//               </button>
//             </form>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProductConcept;

import { useEffect, useState } from "react";
import { useShallow } from "zustand/react/shallow";
import { toast } from "sonner";
import { RegulifyService } from "../../api/RegulifyService";
import { useLoading } from "../../context/LoadingContext";
import { useClinicalEvaluationStore } from "../../store/useClinicalEvaluationStore";
import { normalizeClinicalStudies } from "../../utils/clinicalStudy";
import DateRangePicker from "../DateRangePicker";
import DrugDeviceData from "./DrugDeviceData";

const RESERVED_COLLECTION_NAMES = new Set([
  "class",
  "object",
  "schema",
  "vector",
]);

const formatCompanyName = (value) => {
  const sanitized = value.replace(/[^a-zA-Z0-9 ]/g, "");
  const collapsed = sanitized.replace(/\\s+/g, " ").trimStart();
  const limited = collapsed.slice(0, 50);
  if (!limited) return "";
  return limited.charAt(0).toUpperCase() + limited.slice(1);
};

const formatProductName = (value) => {
  let sanitized = value.replace(/[^a-zA-Z0-9_]/g, "");
  sanitized = sanitized.slice(0, 50);
  if (!sanitized) return "";
  if (/^[a-z]/.test(sanitized)) {
    sanitized = sanitized.charAt(0).toUpperCase() + sanitized.slice(1);
  }
  if (/^[0-9_]/.test(sanitized)) {
    sanitized = sanitized.replace(/^[0-9_]+/, "");
  }
  if (/^[a-z]/.test(sanitized)) {
    sanitized = sanitized.charAt(0).toUpperCase() + sanitized.slice(1);
  }
  return sanitized;
};

const validateCompanyName = (value) => {
  if (!value) return "Company name is required.";
  if (value.length > 50) return "Max 50 characters allowed.";
  if (!/^[A-Z]/.test(value)) return "Must start with an uppercase letter.";
  if (!/^[A-Za-z0-9 ]+$/.test(value))
    return "Only letters, numbers, and spaces allowed.";
  return "";
};

const validateProductName = (value) => {
  if (!value) return "Study name is required.";
  if (value.length > 50) return "Max 50 characters allowed.";
  if (!/^[A-Z]/.test(value)) return "Must start with an uppercase letter.";
  if (!/^[A-Za-z][A-Za-z0-9_]*$/.test(value))
    return "Only letters, numbers, and underscore allowed. No spaces or hyphens.";
  if (/^[0-9]/.test(value)) return "Must not start with a number.";
  if (RESERVED_COLLECTION_NAMES.has(value.toLowerCase()))
    return "This name is reserved. Choose a different name.";
  return "";
};

/* ---------------- Component ---------------- */

const ProductConcept = ({ goToNextTab }) => {
  const { loading, setLoading } = useLoading();
  const selectedStudy = useClinicalEvaluationStore(
    useShallow((state) => state.selectedStudy),
  );
  const setSelectedStudy = useClinicalEvaluationStore(
    (state) => state.setSelectedStudy,
  );

  const [devices, setDevices] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  const [form, setForm] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [isDrug, setIsDrug] = useState(false);

  const [dateRange, setDateRange] = useState({
    minDate: null,
    maxDate: null,
  });

  const updateField = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const setFieldError = (field, error) => {
    setFormErrors((prev) => ({ ...prev, [field]: error }));
  };

  const handleChange = (e) => {
    updateField(e.target.name, e.target.value);
  };

  const handleCompanyNameChange = (e) => {
    const formatted = formatCompanyName(e.target.value);
    updateField("company_name", formatted);
    setFieldError("company_name", validateCompanyName(formatted));
  };

  const handleProductNameChange = (e) => {
    const formatted = formatProductName(e.target.value);
    updateField("product_name", formatted);
    setFieldError("product_name", validateProductName(formatted));
  };

  const handleDateChange = (range) => {
    setDateRange(range);
  };

  /* ---------------- Load Studies ---------------- */

  const loadStudies = async () => {
    try {
      setLoading(true);

      const response =
        await RegulifyService.cle_get_all_clinical_study();

      const normalized = normalizeClinicalStudies(
        response?.data?.study_list
      );

      setDevices(normalized);
      return normalized;
    } catch (err) {
      console.error("Error loading studies:", err);
      return [];
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const syncStudies = async () => {
      const normalized = await loadStudies();
      if (normalized.length === 0) {
        setSelectedStudy(undefined);
        return;
      }

      if (!selectedStudy) {
        setSelectedStudy(normalized[0]);
        return;
      }

      const activeStudy = normalized.find(
        (study) =>
          study.study_folder_name === selectedStudy.study_folder_name ||
          study.product_name === selectedStudy.product_name,
      );

      if (activeStudy) {
        setSelectedStudy(activeStudy);
      } else {
        setSelectedStudy(normalized[0]);
      }
    };

    syncStudies();
  }, []);

  /* ---------------- Create Study ---------------- */

  const createClinicalStudy = async () => {
    try {
      const companyError = validateCompanyName(form.company_name || "");
      const productError = validateProductName(form.product_name || "");
      setFormErrors((prev) => ({
        ...prev,
        company_name: companyError,
        product_name: productError,
      }));
      if (companyError || productError) {
        toast.error(companyError || productError);
        return;
      }

      setLoading(true);

      const payload = {
        ...form,
        users_description: form.users_description,
        population: form.population,
        intervention: form.intervention,
        comparator: form.comparator,
        outcomes: form.outcomes,
        regulatory_references: Array.isArray(form.regulatory_references)
          ? form.regulatory_references
          : [],
        manufacturer_internal_references: Array.isArray(
          form.manufacturer_internal_references,
        )
          ? form.manufacturer_internal_references
          : [],
        date_range_from: dateRange.minDate,
        date_range_to: dateRange.maxDate,
        is_drug: isDrug,
      };

      const res =
        await RegulifyService.cle_create_clinical_study(payload);

      if (res.data.status) {
        setShowForm(false);
        const studies = await loadStudies();
        const createdStudy = studies.find(
          (study) => study.product_name === payload.product_name,
        );
        setSelectedStudy(
          createdStudy || {
            product_name: payload.product_name,
            company_name: payload.company_name || "",
            product_descrp: payload.product_descrp || "",
          },
        );
        goToNextTab();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const isFormComplete = () => {
    return (
      form.product_name &&
      form.company_name &&
      form.product_descrp &&
      form.intended_use &&
      form.users_description &&
      form.population &&
      form.intervention &&
      form.comparator &&
      form.outcomes &&
      dateRange.minDate &&
      dateRange.maxDate &&
      !formErrors.company_name &&
      !formErrors.product_name
    );
  };

  /* ---------------- UI ---------------- */

  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden p-6">

      {/* Header */}
      <div className="mb-6 flex items-center justify-end gap-2">
        {!showForm && !showDetails && (
          <button
            className="btn btn-primary"
            onClick={() => setShowForm(true)}
          >
            Add New Device / Drug
          </button>
        )}

        {!showForm && showDetails && (
          <>
            <button
              type="button"
              className="btn btn-ghost"
              onClick={() => setShowDetails(false)}
            >
              ← Back to list
            </button>
            <button
              type="button"
              className="btn btn-primary font-semibold"
              onClick={goToNextTab}
            >
              Next
            </button>
          </>
        )}

        {showForm && (
          <button
            type="button"
            className="btn btn-ghost"
            onClick={() => setShowForm(false)}
          >
            ← Back to list
          </button>
        )}
      </div>

      {/* ================= TABLE ================= */}

      {!showForm && !showDetails && (
        <div className="min-h-0 flex-1 overflow-auto rounded border bg-base-100">
          <table className="table w-full">

            <thead>
              <tr className="bg-base-200">
                <th>Device / Drug Name</th>
                <th>Type</th>
                <th>Total Journals</th>
                <th>Search terms (Claims relevant)</th>
              </tr>
            </thead>

            <tbody>
              {devices.map((device, idx) => {
                const metricsAvailable =
                  device.metrics &&
                  typeof device.metrics === "object" &&
                  Object.keys(device.metrics).length > 0;
                return (
                <tr
                  key={device.study_folder_name ?? idx}
                  className={`cursor-pointer hover:bg-base-200/50 ${
                    selectedStudy?.study_folder_name === device.study_folder_name
                      ? "bg-primary/10"
                      : ""
                  }`}
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    setSelectedStudy(device);
                    setShowDetails(true);
                  }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      setSelectedStudy(device);
                      setShowDetails(true);
                    }
                  }}
                >
                  <td className="font-medium">
                    {device.product_name}
                  </td>

                  <td>{device.type}</td>

                  <td>
                    {metricsAvailable ? device.total_journals : "No metrics available"}
                  </td>

                  <td className="max-w-xs">
                    {metricsAvailable && device.search_terms?.length ? (
                      <ul className="list-inside list-disc text-sm">
                        {device.search_terms.map(
                          (st, i) => (
                            <li key={i}>
                              <span className="font-medium">
                                {st.term}
                              </span>
                              <span className="text-base-content/70">
                                {" "}
                                → {st.claims_relevant_articles} claims
                              </span>
                            </li>
                          )
                        )}
                      </ul>
                    ) : (
                      "No metrics available"
                    )}
                  </td>
                </tr>
              );
              })}

              {devices.length === 0 && (
                <tr>
                  <td
                    colSpan="4"
                    className="text-center py-6"
                  >
                    No devices found
                  </td>
                </tr>
              )}
            </tbody>

          </table>
        </div>
      )}

      {!showForm && showDetails && selectedStudy && (
        <div className="min-h-0 flex-1 overflow-auto">
          <DrugDeviceData selectedStudy={selectedStudy} />
        </div>
      )}

      {/* ================= FORM ================= */}

      {showForm && (
        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="card w-full border bg-base-100 p-6 shadow">

            <h3 className="mb-4 text-lg font-semibold">
              Add New Device / Drug
            </h3>

            <form
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                if (!loading && isFormComplete()) {
                  createClinicalStudy();
                }
              }}
            >
              <div className="form-control mt-4 w-full">
                <label className="label">
                  <span className="label-text font-semibold">
                    Company name:
                  </span>
                </label>
                <input
                  name="company_name"
                  className="input input-bordered w-full"
                  value={form.company_name || ""}
                  onChange={handleCompanyNameChange}
                  maxLength={50}
                  required
                />
                <span className="label text-xs text-slate-500">
                  Max 50 characters. Letters/numbers/spaces only. First letter uppercase.
                </span>
                {formErrors.company_name && (
                  <span className="label text-xs text-red-600">
                    {formErrors.company_name}
                  </span>
                )}
              </div>

              <div className="form-control mt-4 w-full">
                <label className="label">
                  <span className="label-text font-semibold">
                    Study name:
                  </span>
                </label>
                <input
                  name="product_name"
                  className="input input-bordered w-full"
                  value={form.product_name || ""}
                  onChange={handleProductNameChange}
                  maxLength={50}
                  required
                />
                <span className="label text-xs text-slate-500">
                  1-50 chars, start with uppercase, letters/numbers/underscore only. No spaces or hyphens. Use PascalCase when possible.
                </span>
                <span className="label text-xs text-slate-500">
                  Examples: PubmedArticles, ClinicalEvidence, TumorResistance2026
                </span>
                {formErrors.product_name && (
                  <span className="label text-xs text-red-600">
                    {formErrors.product_name}
                  </span>
                )}
              </div>

              <div className="form-control mt-4 w-full">
                <label className="label">
                  <span className="label-text font-semibold">
                    Problem description:
                  </span>
                </label>
                <textarea
                  name="product_descrp"
                  placeholder="Description"
                  className="textarea textarea-bordered w-full"
                  onChange={handleChange}
                  required
                />
                <span className="label text-xs">
                  (Include - Brief paragraph outlining the problem, its environment, and any relevant contraindications)
                </span>
              </div>

              <div className="form-control mt-4 w-full">
                <label className="label">
                  <span className="label-text font-semibold">
                    Intended use:
                  </span>
                </label>
                <textarea
                  name="intended_use"
                  placeholder="Intended Use"
                  className="textarea textarea-bordered w-full"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-control mt-4 w-full">
                <label className="label">
                  <span className="label-text font-semibold">Patients/Users:</span>
                </label>
                <textarea
                  name="users_description"
                  placeholder="Users Description"
                  className="textarea textarea-bordered w-full"
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="card border border-base-300 bg-base-100">
                <div className="card-body space-y-4">
                  <div className="flex items-center justify-between">
                    <h4 className="text-base font-semibold">PICO</h4>
                    <span className="badge badge-outline">Population · Intervention · Comparator · Outcome</span>
                  </div>

                  <div className="form-control w-full">
                    <label className="label">
                      <span className="label-text font-semibold">Population</span>
                    </label>
                    <textarea
                      name="population"
                      placeholder="Population"
                      className="textarea textarea-bordered w-full"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-control w-full">
                    <label className="label">
                      <span className="label-text font-semibold">Intervention</span>
                    </label>
                    <textarea
                      name="intervention"
                      placeholder="Intervention"
                      className="textarea textarea-bordered w-full"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-control w-full">
                    <label className="label">
                      <span className="label-text font-semibold">Comparator</span>
                    </label>
                    <textarea
                      name="comparator"
                      placeholder="Comparator"
                      className="textarea textarea-bordered w-full"
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="form-control w-full">
                    <label className="label">
                      <span className="label-text font-semibold">Outcome</span>
                    </label>
                    <textarea
                      name="outcomes"
                      placeholder="Outcome"
                      className="textarea textarea-bordered w-full"
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
              </div>

              <fieldset className="form-control border-base-300 mt-4 w-full rounded border p-4">
                <legend className="label label-text px-2 font-semibold">
                  Custom filters:
                </legend>

                <div className="mb-2">
                  <label className="label">
                    <span className="label-text font-semibold">
                      Date range:
                    </span>
                  </label>
                  <DateRangePicker
                    dateRange={dateRange}
                    onDateChange={handleDateChange}
                  />
                </div>

                <div className="mt-4">
                  <label className="label cursor-pointer justify-start gap-3">
                    <input
                      name="is_drug"
                      type="checkbox"
                      className="checkbox checkbox-primary"
                      checked={isDrug}
                      onChange={(e) => setIsDrug(e.target.checked)}
                    />
                    <span className="label-text font-semibold">
                      Is this for Drug
                    </span>
                  </label>
                </div>
              </fieldset>

              <div className="flex gap-3 pt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={!isFormComplete() || loading}
                >
                  Next
                </button>

                <button
                  type="button"
                  className="btn btn-outline"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductConcept;
